import { useLoaderData } from "react-router-dom";
import Page from '../components/page/Page';
import RegistrationForm from '../components/registration-form/RegistrationForm';

export async function loader() {
  const [tokenResponse, settingsResponse, countriesResponse] = await Promise.all([
    fetch('/api/braintree/token'),
    fetch('/api/billing-service-settings'),
    fetch('/api/countries')
  ]);

  const [ { clientToken }, { serviceSettings, bulkPricingRules }, { countries } ] = await Promise.all([
    tokenResponse.json(),
    settingsResponse.json(),
    countriesResponse.json()
  ]);

  return { clientToken, baseCreditPrice: serviceSettings.baseCreditPrice, bulkPricingRules, countries };
}

export default function RegistrationPage() {
  const { clientToken, baseCreditPrice, bulkPricingRules, countries } = useLoaderData() as any;

  return (
    <Page>
      <RegistrationForm clientToken={clientToken} baseCreditPrice={baseCreditPrice} bulkPricingRules={bulkPricingRules} countries={countries} />
    </Page>
  );
}

